import React from "react";
import styles from "./HorizontalScrollSlider.module.css";
import { Link, useNavigate } from "react-router-dom";
import CategoryTitle from "../../reusable/categoryTitle/CategoryTitle";
import CategorySeeAllButton from "../../reusable/categorySeeAll/CategorySeeAll";

const HorizontalScrollSlider = ({ data, title, category_id, category_type }) => {
  const navigate = useNavigate();

  const handleClick = (id) => {
    navigate(`/music/detail/${category_type}/${id}`);
  };

  return (
    <div className={`w-full`}>
      <div className="my-4 flex justify-center">
        <CategoryTitle title={title} />
        {/* <span className="float-right text-yellow-400">See All</span> */}
        <CategorySeeAllButton to={`/music/see_all/${category_id}/${category_type}`} />
      </div>
      <div className={`${styles.imageContainer}`}>
        {data.map((data, index) => (
          <img
            key={index}
            src={data.image}
            alt={`Image ${index + 1}`}
            className={`${styles.image} rounded-lg mr-3`}
            onClick={() => handleClick(data.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default HorizontalScrollSlider;
